module.exports = __webpack_public_path__ + "static/media/sustainability.878b9b11.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/sustainability.jpeg
// module id = 396
// module chunks = 0